import React from 'react';
import Wrapper from './styles';
import { formatPrice } from '../../utils/helpers';
import { Link } from 'react-router-dom';
import { useLanguageContext } from '../../context/language_context';
import { FaArrowRight } from 'react-icons/fa';

const ListView = ({ products }) => {
  const { t } = useLanguageContext();
  
  return (
    <Wrapper>
      {products.map((product) => {
        const { id, image, name, price, description } = product;
        return (
          <article key={id}>
            <img src={image} alt={name} />
            <div className='content'>
              <h4>{name}</h4>
              <p className='price'>{formatPrice(price)}</p>
              <p>{description?.substring(0, 150)}...</p>
              <Link to={`/products/${id}`} className='btn'>
                {t.products?.quickView || 'View Details'}
                <FaArrowRight />
              </Link>
            </div>
          </article>
        );
      })}
    </Wrapper>
  );
};

export default ListView;
